export default __webpack_public_path__ + "static/Plots0009-3f938b3025aaff31f7acfaa3a04347f1.jpg";